//import libraries
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Resolve } from '@angular/router';

//import constants
import { AppSettings } from '../constants/app-settings';
import { AppBackRoutes } from '../constants/app-back-routes';


//import language
import { ServicingListLang, ServicingCreateLang, ServicingViewLang, ServicingUserLang, SettingsListLangForm, SettingsEditLangForm, SettingsSettingsLang, ServicingCalendarLang, ServicingGeneralLang, ServicingMaintenancePlanningLang, ServicingViewGeneralLang, ServicingMaintenanceLang, ServicingOrdinaryLang, ServicingExOrdinaryLang, ServicingDocumentsLang } from '../languages/Servicing.Lang';


import { AuditListLang } from '../languages/Audit.Lang';


//import services
import { GeneralService } from '../services/general.service';

//import classes
// import {
//     SettingsFormMangIn, SettingsFormMangOut
//   } from '../classes/settings.model';

import {
    ServicingList, ServicingGeneralGet, ServicingGeneralPostIn, ServicingGeneralPostOut } from '../classes/servicing.model';
import { data } from 'jquery';


@Injectable()


export class AuditService implements Resolve<Observable<any>>{

    constructor(
        private http: HttpClient,
        private generalService: GeneralService,
    ) { }

    resolve() {
        return this.ServicingGetData();
    }

    ServicingGetData(): Observable<ServicingList> {

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.servicingMaintenancelist;
        return this.http.get<any>(url);

    }
    
    listLang(details: any) {

        if (!details) return;

        // console.log('test');

        let instance = new AuditListLang(details.data.language);
        return instance.lang();

    }

    ServicingMaintenanceLang(details: any) {

        if (!details) return;
        let instance = new ServicingMaintenanceLang(details.data.language);
        return instance.lang();
    }

    
    GeneralPostData(data: ServicingGeneralPostIn) {

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.profileGeneralPost;
        return this.http.post<ServicingGeneralPostOut>(url, data);
    }

    generalLang(details: any) {

        if (!details) return;

        let instance = new ServicingGeneralLang(details.data.language);
        return instance.lang();

    }


    createLang(details: any) {

        if (!details) return;

        let instance = new ServicingCreateLang(details.data.language);
        return instance.lang();

    }

    update(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.servicingCreate;
        return this.http.post<any>(url, data);
    }


    updateStandard(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.updateStandard;
        return this.http.post<any>(url, data);
    }

    updateChapter(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.updateChapter;
        return this.http.post<any>(url, data);
    }    

    addEditClause(mode,data: any) {
        if(mode == "add")
            var url = AppSettings.API_ENDPOINT + AppBackRoutes.editAuditClause;
        else if(mode == "edit")
            var url = AppSettings.API_ENDPOINT + AppBackRoutes.editAuditClause;
        return this.http.post<any>(url, data);
    }        

 

    

    sorting(data: any, table: any) {

        let data1 = { 'id': data, 'table': { 'table_name': 'service', 'id': 'serviceId', 'order': 'sort1' } };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.employeeSorting;
        // console.log(url);
        return this.http.post<any>(url, data1);
    }


    sorting1(data: any, table: any) {

        let data1 = { 'id': data, 'table': { 'table_name': 'kaizen_measurement_calibration_plan', 'id': 'pk_maintenance_plan_id', 'order': 'sort1' } };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.employeeSorting;
        // console.log(url);
        return this.http.post<any>(url, data1);
    }


    update_extraordinary(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.exordinary_servicing;
        return this.http.post<any>(url, data);
    }

    update_ordinary(data: any) {
        // console.log(data); return false;
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.ordinary_servicing;
        return this.http.post<any>(url, data);
    }

    update_mplans(data: any) {
        // console.log(data); return false;
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.ordinary_servicing;
        return this.http.post<any>(url, data);
    }

    update_maintenance(data: any) {
        // console.log(data); return false;
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.update_maintenance;
        return this.http.post<any>(url, data);
    }
    
    update_documents(data: any) {
        // console.log(data); return false;
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.update_documents;
        return this.http.post<any>(url, data);
    }


    edit(id: any) {
        let data = {'action' : 'edit_service', 'id' : id};
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.servicingCreate;
        return this.http.post<any>(url, data);
    }

    edit_ordinary(id: any, sid: any, pid: any) {

        let data = { 'data_action': 'modify','action': 'intervention_update', 'intervention_id': id, 'service_id': sid, 'plan_id': pid };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.edit_ordinary;
        return this.http.post<any>(url, data);
    }


    edit_extraordinary(id: any) {
        let data = {'action' : 'edit_extraordinary', 'id' : id};
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.edit_extraordinary;
        return this.http.post<any>(url, data);
    }

    
    editMaintenanceformdata(id: any) {
        let data = {'action' : 'maintenance_form', 'plan_id' : id};
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.editMaintenanceformdata;
        return this.http.post<any>(url, data);
    }


    edit_documents(id: any) {
        let data = { 'data_action': 'modify','action': 'edit_documents','docId': id };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.edit_documents;
        return this.http.post<any>(url, data);
    }

    

    duplicate(id: any) {

        let data = [id];
        return this.multiDuplicate(data);
        
    }

    multiDelete(ids: any) {
        let data = { 'cid': ids };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.servicingMultiDelete;
        return this.http.post<any>(url, data);
    }
    
    multiDelete1(ids: any) {
        let data = { 'id': ids };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.servicingMainMultiDelete;
        return this.http.post<any>(url, data);
    }

    multiDelete_maintenance(ids: any) {
        let data = { 'plan_ids': ids, 'action' : 'plans_table_delete' };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.multiDeleteMaintenance;
        return this.http.post<any>(url, data);
    }


    
        
    delete_mextraordinary(ids: any) {
        let data = { 'id': ids };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.delete_mextraordinary;
        return this.http.post<any>(url, data);
    }
    
        
        
    delete_msdocuments(ids: any) {
        let data = { 'id': ids,'action' : 'multidelete_documents' };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.delete_msdocuments;
        return this.http.post<any>(url, data);
     }


    multiDuplicate(ids: any) {

        let data = {'sid' : ids};

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.servicingMultiDuplicate;
        return this.http.post<any>(url, data);

    }
    multiOrdDuplicate(ids: any) {

        let data = {'id' : ids};

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.multiOrdDuplicate;
        return this.http.post<any>(url, data);

    }
    
    
    multiExtraDuplicate(ids: any) {

        let data = {'id' : ids};

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.multiExtraDuplicate;
        return this.http.post<any>(url, data);

    }

    multiDuplicate_maintenance(ids: any) {

        let data = {'plan_ids' : ids, 'action' : 'plans_table_copy' };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.multiDuplicateMaintenance;
        return this.http.post<any>(url, data);

    }

    doc_multiDuplicate(ids: any) {

        let data = {'id' : ids, 'action' : 'multiduplicate_documents'};

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.duplicate_msdocuments;
        return this.http.post<any>(url, data);

    }

    

    getList(){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.servicingList;
        return this.http.get<any>(url);

    }

    getauditList(){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.getauditList;
        return this.http.get<any>(url);

    }

    getstandardList(){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.getstandardList;
        return this.http.get<any>(url);
    }



    getServicingList(){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.getServicingList;
        return this.http.get<any>(url);
    }


    getMaintenanceformdata(){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.getMaintenanceformdata;
        return this.http.get<any>(url);

    }


    getMaintenanceList(){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.maintenancePlans;
        return this.http.get<any>(url);
    }
    

    exordinaryData(id: any){

        let data = { 'eid': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.exordinaryData;
        return this.http.post<any>(url, data);

    }


    ordinaryData(id: any){

        let data = { 'oid': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.ordinaryData;
        return this.http.post<any>(url, data);

    }


    documentsData(id: any){

        let data = { 'action': 'add_documents','docid': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.documentsData;
        return this.http.post<any>(url, data);

    }


    generalList(id: any){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.generalList + '/' + id;
        return this.http.get<any>(url);

    }

    GeneralGetServData(resp: ServicingGeneralGet) {
        console.log(resp);
        return (resp) ? resp.data.single_data : null;
    }


    //     resolve() {
    //     return this.FetchDetails();
    // }

    // FetchDetails(): Observable<any> {

    //     let url = AppSettings.API_ENDPOINT + AppBackRoutes.settingsData;
    //     return this.http.get<any>(url);

    // }

    getlistLangForm(details: any) {

        if (!details) return;

        let instance = new SettingsListLangForm(details.language);
        return instance.lang();

    }

    getEditLangForm(details: any) {

        if (!details) return;

        let instance = new SettingsEditLangForm(details.language);
        return instance.lang();

    }

    getSettingsLang(details: any) {

        if (!details) return;

        let instance = new SettingsSettingsLang(details.language);
        return instance.lang();

    }

    // FormMangServCall(input : SettingsFormMangIn) {
    //     let url = AppSettings.API_ENDPOINT + AppBackRoutes.settingsFormMang;
    //     return this.http.post<SettingsFormMangOut>(url, input);
    // }

    FormMangUpdate(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.settingsFormMang;
        return this.http.post<any>(url, data);
    }

    settingsUpdate(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.settingsSettings;
        return this.http.post<any>(url, data);
    }

    get_standard_info(standard_id: any) {
        const data = { "standard_id":standard_id }
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.GetAuditStandardInfo;
        return this.http.post<any>(url, data);
    }    
    
    delete(id: any) {
        let data = { 'id': id };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.servicingDelete;
        return this.http.post<any>(url, data);
    }

    getClauseInfo(standard_id,chapter_id,clause_id) {
        let data = { 'standard_id': standard_id, 'chapter_id': chapter_id, 'clause_id':clause_id };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.ClauseInfo;
        return this.http.post<any>(url, data);
    }     
    
    delete_standard(level,standard_id: any,chapter_id,clause_id: any) {
        let data = { 'standard_id': standard_id, 'chapter_id': chapter_id, 'clause_id': clause_id };
        let url = ""
        if(level == 0)
             url = AppSettings.API_ENDPOINT + AppBackRoutes.AuditStandardDelete;
        else if(level == 1)
            url = AppSettings.API_ENDPOINT + AppBackRoutes.DeleteChapter;
        else if(level == 2)
            url = AppSettings.API_ENDPOINT + AppBackRoutes.AuditClauseDelete;        
        return this.http.post<any>(url, data);
    }
    

    deleteAuditReportMail(id: any,mail_id) {

        let data = { 'audit_id': id, 'mail_id': mail_id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.AuditReportSendMailDelete;
        return this.http.post<any>(url, data);

    }  
    
    triggerReportMail(id: any,mail_id) {

        let data = { 'audit_id': id, 'mail_id': mail_id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.AuditTriggerReortMail;
        return this.http.post<any>(url, data);

    }      


    delete_extraordinary(id: any) {

        let data = { 'id': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deleteExtraordinary;
        return this.http.post<any>(url, data);

    }

    delete_ordinary(id: any) {

        let data = { 'id': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deleteOrdinary;
        return this.http.post<any>(url, data);

    }

    deleteMultiOrdinary(id: any) {

        let data = { 'cid': id };

        // console.log(data);

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deleteMultiOrdinary;
        return this.http.post<any>(url, data);

    }

    
    
    delete_maintenance(id: any) {

        let data = { 'plan_id': id, 'action' : 'plans_delete' };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deleteMaintenance;
        return this.http.post<any>(url, data);

    }

    
    
    delete_sdocuments(id: any) {

        let data = { 'docId': id, 'action' : 'delete_documents' };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deleteDocuments;
        return this.http.post<any>(url, data);

    }

    updateProfile(profileImage: any){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.servicinguploadExcel;
 
         let headers = new HttpHeaders({
             'Content-Type': 'application/json'
          });
 
         let options = {
             headers: headers
          }
 
         let data = {'profile' : profileImage};
          return this.http.post<any>(url, data, options);
 
    }
    


    updateImport(profileImage: any){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.documentsuploadExcel;
 
         let headers = new HttpHeaders({
             'Content-Type': 'application/json'
          });
 
         let options = {
             headers: headers
          }
 
         let data = {'profile' : profileImage,'action': 'import_documents'};
          return this.http.post<any>(url, data, options);
 
    }
    


    mLangData(details: ServicingList) {
        if (!details) return;

        // console.log('test');

        let instance = new ServicingMaintenancePlanningLang(details.data.language);
        return instance.lang();


        // if (!resp)
        //     return;

        // let lang = {};

        // let gen = resp.data.language.general;
        // // console.log(gen);
        // lang = Object.assign(lang, { general: this.generalService.service_inject(ServicingUserLang.general, gen) });

        // let dash = resp.data.language.service;
        // lang = Object.assign(lang, { user: this.generalService.service_inject(ServicingUserLang.user, dash) });

        // return lang;
    }

    servicingviewLang(details: ServicingList) {
        if (!details) return;

        let instance = new ServicingViewGeneralLang(details.data.language);
        return instance.lang();

    }


    ServicingOrdinaryLang(details: ServicingList) {
        if (!details) return;

        let instance = new ServicingOrdinaryLang(details.data.language);
        return instance.lang();

    }

    ServicingExOrdinaryLang(details: ServicingList) {
        if (!details) return;

        let instance = new ServicingExOrdinaryLang(details.data.language);
        return instance.lang();

    }
    

    ServicingDocumentsLang(details: ServicingList) {
        if (!details) return;

        let instance = new ServicingDocumentsLang(details.data.language);
        return instance.lang();

    }

    MaintenanceData(resp: ServicingList) {

        // console.log(resp);

        return (resp) ? resp.data.all_mplans : null;
    }

    calendar(){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.servicingCalendar;
        return this.http.get<any>(url);

    }

    calendarLang(details: any) {

        if (!details) return;
        let instance = new ServicingCalendarLang(details.data.language);
        return instance.lang();

    }

    turnoff(sID : any,pid : any,rid : any) {

        let data = { 'sID': sID, 'pid': pid, 'rid': rid };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.servicingTurnoff;
        return this.http.post<any>(url, data);

    }

    active_status(date : any,plan_id_forcd : any,pservice_id : any) {

        let data = { 'start_date': date, 'plan_id_forcd': plan_id_forcd, 'service_id': pservice_id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.active_status;
        return this.http.post<any>(url, data);

    }

    Plancodecheck(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.check_plancode;
        return this.http.post<any>(url, data, { headers: new HttpHeaders({'loader': 'false'}) });
    }

    getAuditDrodown(){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.getauditDropdown;
        return this.http.get<any>(url);        
    }

    getStdClauseDropdown(stdId,auditId){
        let data = { 'standard_id': stdId, 'audit_id': auditId };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.getStdClauseDropdown;
        return this.http.post<any>(url, data);   
    }   
    
    getChapterInfo(stdId,chapterId){
        let data = { 'standard_id': stdId, 'chapter_id': chapterId };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.GetChapterInfo;
        return this.http.post<any>(url, data);   
    }       

    addAudit(data){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.addAudit;
        return this.http.post<any>(url, data);           
    }

    getAuditInfo(id){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.getAuditInfo;
        return this.http.post<any>(url, {"audit_id":id});                   
    }

    generateAuditPlanReport(data,type){
        let url = (type=="audit_plan") ? AppSettings.API_ENDPOINT + AppBackRoutes.generateAuditPlanReport: AppSettings.API_ENDPOINT + AppBackRoutes.generateAuditReportPdf;
        return this.http.post<any>(url, data);                   
    }    

    generateAuditReport(data){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.generateAuditReport;
        return this.http.post<any>(url, data);                   
    }        

    getAuditUserData(){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.AuditUserData;
        return this.http.get<any>(url);           
    }

    delete_audit(id){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deleteAudit;
        return this.http.post<any>(url, {"audit_id":id});                           
    }

    sendAuditMail(type,data){
        let url = (type == "mail_plan")?AppSettings.API_ENDPOINT + AppBackRoutes.AuditSendMail:AppSettings.API_ENDPOINT + AppBackRoutes.AuditReportSendMail;
        return this.http.post<any>(url, data);                           
    }
    
    saveDocsForm(params){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.SaveDocsForm;
        return this.http.post<any>(url, params);                                   
    }

    saveAuditing(params){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.SaveAuditing;
        return this.http.post<any>(url, params);                                   
    }

    addRemarks(){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.AddRemarks;
        return this.http.get<any>(url);                                   
    }    

    getDocsInfoForm(params){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.GetDocsInfoForm;
        return this.http.post<any>(url, params);                                   
    }    
    
}